var MILLISECONDS_PER_SECONDS = 1000;
var SESSION_STORAGE_KEYS_TO_REMOVE_ONLOGIN = [
    'UserFiltersLSK',
    'UserFiltersSearchText',
];
/**
 * Remove all the keys from the session storage at the login
 */
export var cleanSessionStorageOnLogin = function () {
    SESSION_STORAGE_KEYS_TO_REMOVE_ONLOGIN.forEach(function (key) {
        return sessionStorage.removeItem(key);
    });
};
var clearOldSessionData = function (prefix, instance) {
    if (prefix) {
        var removeList = [];
        for (var i = 0; i < sessionStorage.length; i++) {
            var keyItem = sessionStorage.key(i);
            if ((keyItem === null || keyItem === void 0 ? void 0 : keyItem.includes(prefix)) && !(keyItem === null || keyItem === void 0 ? void 0 : keyItem.includes(instance))) {
                removeList.push(keyItem);
            }
        }
        removeList.forEach(function (toRemove) { return sessionStorage.removeItem(toRemove); });
    }
};
export var getWithExpiry = function (prefix, instance) {
    if (prefix === void 0) { prefix = ''; }
    var key = [prefix, instance].filter(function (val) { return val; }).join('-');
    var value = sessionStorage.getItem(key);
    if (!value) {
        return null;
    }
    var jsonValue = JSON.parse(value);
    var now = new Date().getTime();
    if ((jsonValue === null || jsonValue === void 0 ? void 0 : jsonValue.expiry) > now) {
        return jsonValue.item;
    }
    return null;
};
export var setWithExpiry = function (prefix, instance, item, secondsTtl) {
    if (prefix === void 0) { prefix = ''; }
    clearOldSessionData(prefix, instance);
    var expiresOn = new Date().getTime() + secondsTtl * MILLISECONDS_PER_SECONDS;
    var jsonValue = {
        expiry: expiresOn,
        item: item,
    };
    var key = [prefix, instance].filter(function (val) { return val; }).join('-');
    sessionStorage.setItem(key, JSON.stringify(jsonValue));
};
